import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import IconButton from "../IconButton";

import styles from "./index.css";

class Notification extends Component {
  constructor() {
    super();
    this.state = { dismissed: false };
  }

  handleClose = () => {
    this.setState({ dismissed: true });
  };

  render() {
    const ariaLiveForType = {
      alert: "assertive",
      error: "assertive",
      promotion: "polite",
      success: "polite"
    };

    const { children, hasIcon, type, withClose, closeLabel } = this.props;
    const { dismissed } = this.state;

    if (dismissed) return null;

    return (
      <div
        aria-live={ariaLiveForType[type]}
        className={classnames({
          [styles.notification]: true,
          [styles[type]]: true,
          [styles.hasBackground]: true,
          [styles.hasIcon]: hasIcon
        })}
      >
        <div className={styles.text}>{children}</div>
        {withClose && (
          <IconButton
            icon="close"
            className={styles.close}
            data-testid="notification-close-btn"
            size="small"
            onClick={this.handleClose}
            aria-label={closeLabel ? closeLabel : "Dismiss this message"}
          />
        )}
      </div>
    );
  }
}

Notification.propTypes = {
  children: PropTypes.node.isRequired,
  hasIcon: PropTypes.bool,
  type: PropTypes.oneOf(["alert", "error", "promotion", "success"]).isRequired,
  withClose: PropTypes.bool,
  closeLabel: PropTypes.string
};

Notification.defaultProps = {
  hasIcon: true,
  withClose: false
};

export default Notification;



// WEBPACK FOOTER //
// ./template/components/Notification/index.js